import React from 'react';
import cn from 'classnames';

import * as styles from './index.module.css';

export type NotificationMarkVariant = 'critical' | 'brandPrimary';

export type NotificationMarkProps = {
  variant?: NotificationMarkVariant;
  className?: string;
};

export function NotificationMark({ className, variant = 'brandPrimary' }: NotificationMarkProps) {
  return <div className={cn(className, styles[variant], styles.notification)} />;
}
